module.exports = {
  TOKEN_TABLEAU: 'token_tableau',
  LOGIN_SUCCESS: 'login_success',
  TOKEN_SUCCESS: 'token_success',
  SET_USER: 'set_user',
  CLEAR_PERSISTED_DATA: 'clear_persisted_data',
  SYSTEM_TOAST_ERROR_MESSAGE: 'system_toast_error_message',
  SYSTEM_TOAST_SUCCESS_MESSAGE: 'system_toast_success_message',
  SYSTEM_TOAST_INFO_MESSAGE: 'system_toast_info_message',
  SYSTEM_TOAST_WARNING_MESSAGE: 'system_toast_warning_message',
  SYSTEM_TOAST_CLEAR: 'system_toast_clear',
  SYSTEM_LINKS_MAIS_MANSERV: 'system_links_mais_manserv',
  LOGOUT: 'logout',
  GET_BANNERS: 'get_banners',
  GET_HOME_BANNERS: 'get_home_banners',
  GET_BANNER: 'get_banner',
  GET_CONTRACTS: 'get_contracts',
  GET_CONTRACT: 'get_contract',
  GET_COMMUNICATED: 'get_communicated',
  GET_COMMUNICATION: 'get_communication',
  GET_TEMPLATES: 'get_templates',
  GET_TEMPLATE: 'get_template',
  GET_BIRTHDAYS: 'get_birthdays',
  GET_ALL_BIRTHDAYS: 'get_all_birthdays',
  GET_WEATHER: 'get_weather',
  GET_USERS: 'get_users',
  GET_APPS: 'get_apps',
  GET_FAVORITE_APPS: 'get_favorite_apps',
  GET_NOTIFICATIONS: 'get_notifications',
  GET_SECURETEXT: 'get_securetext', 
  GET_SECURETEXTS: 'get_securetexts'
};
